export default __webpack_public_path__ + "static/media/task2.3fc11ed1.png";